import { RootState } from '../../../rootReducer';
import { CreateConnectorState } from './types';

export const selectCreateConnectorState = (state: RootState): CreateConnectorState =>
  state.connectors.create;
